class UploadToken {
  constructor(token
  /*: string*/
  , uploadUrl
  /*: string*/
  ) {
    this.token = token;
    this.uploadUrl = uploadUrl;
  }

}

module.exports = UploadToken;